export const USER_RECHARGE_PERMISSION = 'credits:recharge';
export const USER_GIFT_PERMISSION = 'credits:gift';
export const USER_DEDUCT_PERMISSION = 'users:adjust_credits';
export const USER_LIST_PERMISSION = 'users:list';
export const USER_DETAIL_PERMISSION = 'users:detail';
export const USER_BAN_PERMISSION = 'users:ban';
export const USER_DISABLE_PERMISSION = 'users:disable';
export const USER_REMARK_PERMISSION = 'users:remark';
export const USER_EXPORT_POLICY_PERMISSION = 'users:manage_export_policy';

export function canOpenUserDetail(hasPermission: (code: string) => boolean): boolean {
  return hasPermission(USER_DETAIL_PERMISSION);
}
